import React, { useEffect, useState } from 'react';
import styles from '../style.module.scss';

import moment from 'moment';

import { useHistory } from 'react-router-dom';
import NewHeaderComponent from '../../../components/NewHeader/NewHeader';
import { PHONE_PREFIX, SUPPORT_EMAIL, SUPPORT_PHONE } from '../../../components/SideNav/constant';

import { Context as AuthContext } from '../../../Redux/context/AuthContext';
import Dialog from '../../../components/Dialog';
import useProductData from '../Hooks/useProductData';
import ProductCard from './productCard';
import AddCatalogueComponent from '../../Inventory/addCatalogue';
import AlertComponent from '../../../components/AlertComponent';
import { Button, Modal } from 'react-bootstrap';

import Lottie from 'lottie-react';
import sparkleAnimation from '../../../lotties/Sparkel.json';
import productsAnimation from '../../../lotties/ProductsAdded.json';
import getApobSupplierId from '../../../utils/getApobSupplierId';
import TermsAndConditionPage from '../../../pages/TermsAndCondition';
import { moengageTrackEvent } from '../../../Analytics/moengageEventFunction';

const UserJourney = ({ isAdmin }) => {
  const history = useHistory();

  const {
    onFetchRecommendedProducts,
    totalProducts,
    searchModelIdFnc,
    searchedModelId,
    productArray,
    selectedModelFnc,
    clearSearchResult,
    addProductObj,
    productObj,
    showModelDetails,
    showAddNewBtn,
    showCatalogueModal,
    setShowCatalogueModal,
    addInv,
    category,
    handleInvModal,
    getCategoryList,
    showAlert,
    setShowAlert,
    alertMsg,
    getUserJourneyDetails,
    showSuccessPopup,
    setShowSuccessPopup,
    successPopupType,
    setSuccessPopupType,
    showAddProduct,
    setShowAddProduct,
    addLoading,
    errorMsg,
    setErrorMsg,
  } = useProductData();

  const [openPolicy, setOpenPolicy] = useState(false);

  const { apobSupplierID } = getApobSupplierId();

  useEffect(() => {
    getUserJourneyDetails(isAdmin ? apobSupplierID : null);
  }, []);

  const { logout } = React.useContext(AuthContext);
  const loginData = localStorage.getItem('login_data')
    ? JSON.parse(localStorage.getItem('login_data'))
    : null;

  const userJourney = loginData?.userJourney;

  const dayDifference = loginData?.salesDays;

  const salesBoostOn = loginData?.salesBoostOn;

  const [logoutPopup, setLogoutPopup] = useState(false);

  const endSession = async () => {
    await logout();
  };

  const handleDialogAction = (flag) => {
    if (flag) endSession();
    setLogoutPopup(false);
  };

  const registrationProgress =
    userJourney?.REGISTRATION_STATUS?.progress === 0
      ? 'not_started'
      : userJourney?.REGISTRATION_STATUS?.progress === 100
      ? 'completed'
      : 'in_progress';

  const catalogueProgress =
    userJourney?.INVENTORY_ADDITION_STATUS?.progress === 0
      ? 'not_started'
      : userJourney?.INVENTORY_ADDITION_STATUS?.progress === 100
      ? 'completed'
      : 'in_progress';

  const orderReceivedProgress =
    userJourney?.ORDER_RECIEVED?.progress === 0
      ? 'not_started'
      : userJourney?.ORDER_RECIEVED?.progress === 100
      ? 'completed'
      : 'in_progress';

  const orderAcceptedProgress =
    userJourney?.ORDER_ACCEPTED?.progress === 0
      ? 'not_started'
      : userJourney?.ORDER_ACCEPTED?.progress === 100
      ? 'completed'
      : 'in_progress';

  useEffect(() => {
    if (catalogueProgress === 'completed') {
      onFetchRecommendedProducts();
    }
  }, [catalogueProgress]);

  return (
    <div style={{ marginTop: '-20px' }} className={`pb-1 ${styles.userJourneyScreen}`}>
      {/* <NewHeaderComponent /> */}

      <AddCatalogueComponent
        searchModelIdFnc={searchModelIdFnc}
        searchedModelId={searchedModelId}
        modelArray={productArray}
        selectedModelFnc={selectedModelFnc}
        clearSearchResult={clearSearchResult}
        addProductObj={addProductObj}
        productObj={productObj}
        showModelDetails={showModelDetails}
        showAddNewBtn={showAddNewBtn}
        show={showCatalogueModal}
        handleClose={() => setShowCatalogueModal(false)}
        addInv={addInv}
        category={category}
      />
      <AlertComponent
        color={alertMsg.color}
        msg={alertMsg.msg}
        open={showAlert}
        handleClose={() => setShowAlert(false)}
      />

      <div className="modal_box">
        <Modal
          className="main_modal"
          show={showSuccessPopup}
          onHide={() => {
            setSuccessPopupType(null);
            setShowSuccessPopup(false);
          }}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body className="p-5">
            <div className={`text-center ${styles.animationContainer}`}>
              <Lottie
                style={{ marginTop: '-40px', width: '300px' }}
                className={`${styles.modal_sparkleAnimation}`}
                animationData={sparkleAnimation}
                loop={true}
              />
              <Lottie
                style={{ marginTop: '-80px' }}
                className={`${styles.modal_houseAnimation}`}
                animationData={productsAnimation}
                loop={true}
              />
              {/* <img src="/svg/confirmation-icon.svg" alt="alt-text" width={64} /> */}
              <h4
                style={{ marginTop: '140px' }}
                className={`${styles.modal_title} ${styles.simpleBlueText}`}
              >
                Congratulations!
              </h4>
              <p className={styles.tinyFont}>Your product has been successfully added</p>
              <Button
                className={styles.modal_button}
                onClick={() => {
                  setShowSuccessPopup(false);
                  setSuccessPopupType(null);
                }}
              >
                Continue
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>

      {logoutPopup ? <Dialog open={logoutPopup} onAction={handleDialogAction} /> : null}

      <div className={`${styles.userJourneyContainer}`}>
        <div className={`${styles.userJourneyHeader}`}>
          <span>
            Welcome, <b>{loginData?.name || loginData?.sellerName}</b>
          </span>

          <div className={`d-flex flex-wrap`} style={{ gap: '10px' }}>
            <a href={`mailto:${SUPPORT_EMAIL}`}>
              <img src="/images/Message.svg" />
            </a>
            <a href={`tel:${PHONE_PREFIX + SUPPORT_PHONE}`}>
              <img className={``} src="/images/Call.svg" />
            </a>
            <img
              onClick={() => {
                setLogoutPopup(true);
              }}
              className={`mt-1`}
              src="/images/Logout.svg"
            />
          </div>
        </div>

        <span
          className={`${styles.blueText} mr-auto mt-3`}
          onClick={() => {
            setOpenPolicy(true);
            moengageTrackEvent('Seller_policy_viewed', {});
          }}
        >
          Falcon Policy
        </span>

        <div className={`${styles.appliancesContainer}`}>
          <div className={`d-flex flex-column mt-4`}>
            <span className={`font-weight-normal`}>NOW GROW WITH</span>
            <span>Falcon</span>
            <span>Sell your products to 100K retailers</span>
          </div>
          <img className={`ml-4`} src="/images/Appliances2.svg" />
        </div>

        <div className={`${styles.journeyDetailsContainer}`}>
          {salesBoostOn && (
            <span className={`${styles.salesBoost}`}>
              Sales boost is <b>ON! {dayDifference} days</b> left
            </span>
          )}

          {/* 1st step */}
          <div className={`mt-4 ${styles.journeyStep}`}>
            <div className={`d-flex flex-column align-items-center`}>
              <img className={``} src="/images/blueTick.svg" />
              <div className={`${styles.activeLine}`} />
            </div>
            <div className={`pb-4 ml-3 d-flex flex-column ${styles.journeyStepInfo}`}>
              <div className={`d-flex align-items-center`}>
                <img className={``} src="/images/Store.svg" />
                <span className={`ml-2 ${styles.smallSemibold} font-weight-bold`}>
                  Complete Registration
                </span>
              </div>
              <span className={`mt-2 ${styles.grayText}`}>
                Congrats! Complete setup now!{' '}
                {/* <span className={`${styles.underlineBlueText}`}>welcome offer!</span> */}
              </span>
              <span
                onClick={() => {
                  history.push('/vendor-details');
                }}
                style={{ fontSize: '14px' }}
                className={`mt-2 ${styles.blueText}`}
              >
                Edit Details
              </span>
            </div>
          </div>

          {/* 2nd step */}
          <div className={`${styles.journeyStep}`}>
            <div className={`d-flex flex-column align-items-center`}>
              {catalogueProgress == 'completed' ? (
                <img className={``} src="/images/blueTick.svg" />
              ) : (
                <img className={``} src="/images/inprogressJourney.svg" />
              )}
              {catalogueProgress == 'completed' ? (
                <div className={`${styles.activeLine}`} />
              ) : (
                <div className={`${styles.inactiveLine}`} />
              )}
            </div>
            <div className={`pb-4 ml-3 d-flex flex-column ${styles.journeyStepInfo}`}>
              <div className={`d-flex align-items-center`}>
                <img className={``} src="/images/Box.svg" />
                <span
                  className={`ml-2 ${styles.smallSemibold} ${
                    catalogueProgress == 'completed'
                      ? 'font-weight-bold'
                      : `font-weight-bold ${styles.simpleBlueText}`
                  }`}
                >
                  Add Products
                </span>
              </div>
              <span className={`mt-2 ${styles.journeyDescription}`}>
                {catalogueProgress == 'completed'
                  ? 'Seize the moment! Add more products, improve pricing, and maximise sales!'
                  : 'Add products, set lower prices, and discover hot-selling recommendations.'}
              </span>
              {catalogueProgress == 'completed' ? (
                <span
                  onClick={() => {
                    history.push('/catalogue');
                  }}
                  style={{ fontSize: '14px' }}
                  className={`mt-2 ${styles.blueText}`}
                >
                  View Catalogue
                </span>
              ) : (
                <button
                  onClick={() => {
                    history.push('/recommended-products');
                  }}
                  className={`mt-3 ${styles.blueButton}`}
                >
                  <span>Add Products</span>
                </button>
              )}
            </div>
          </div>

          {/* 3rd step */}
          <div className={`${styles.journeyStep}`}>
            <div className={`d-flex flex-column align-items-center`}>
              {catalogueProgress !== 'completed' ? (
                <img className={``} src="/images/pendingJourney.svg" />
              ) : orderAcceptedProgress == 'completed' ? (
                <img className={``} src="/images/blueTick.svg" />
              ) : (
                <img className={``} src="/images/inprogressJourney.svg" />
              )}
              {orderAcceptedProgress == 'completed' ? (
                <div className={`${styles.activeLine}`} />
              ) : (
                <div className={`${styles.inactiveLine}`} />
              )}
            </div>
            <div className={`pb-4 ml-3 d-flex flex-column ${styles.journeyStepInfo}`}>
              <div className={`d-flex align-items-center`}>
                <img
                  className={`${catalogueProgress !== 'completed' ? styles.fillGray : ''}`}
                  src="/images/Buy.svg"
                />
                <span
                  className={`ml-2 ${styles.smallSemibold} ${
                    catalogueProgress !== 'completed'
                      ? styles.disabledGrayText
                      : orderAcceptedProgress == 'completed'
                      ? 'font-weight-bold'
                      : `font-weight-bold ${styles.simpleBlueText}`
                  }`}
                >
                  {orderReceivedProgress == 'completed'
                    ? 'Ship Order on time!'
                    : 'Get your first order!'}
                </span>
              </div>
              {catalogueProgress == 'completed' &&
                (orderReceivedProgress == 'not_started' ? (
                  <React.Fragment>
                    <span className={`mt-2 ${styles.journeyDescription}`}>
                      Seize the moment! Add more products, improve pricing, and maximise sales!
                    </span>
                    <button
                      onClick={() => {
                        history.push('/recommended-products');
                      }}
                      className={`mt-3 ${styles.blueButton}`}
                    >
                      <span>Add More Products</span>
                    </button>
                  </React.Fragment>
                ) : orderAcceptedProgress == 'completed' ? (
                  <span className={`mt-2 ${styles.journeyDescription}`}>
                    Your Satisfaction is Our Priority
                  </span>
                ) : (
                  <React.Fragment>
                    <span className={`mt-2 ${styles.journeyDescription}`}>
                      Congrats on your first order! Ship orders within a day to get more orders.
                    </span>
                    <button
                      onClick={() => {
                        history.push('/my-orders');
                      }}
                      className={`mt-3 ${styles.blueButton}`}
                    >
                      <span>Ship Order</span>
                    </button>
                  </React.Fragment>
                ))}
              {/* {orderReceivedProgress == 'completed' && (
                <span className={`mt-2 ${styles.journeyDescription}`}>
                  Your Satisfaction is Our Priority
                </span>
              )} */}
            </div>
          </div>

          {/* 4th step */}
          <div className={`${styles.journeyStep}`}>
            <div className={`d-flex flex-column align-items-center`}>
              {orderAcceptedProgress == 'completed' ? (
                <img className={``} src="/images/inprogressJourney.svg" />
              ) : (
                <img className={``} src="/images/pendingJourney.svg" />
              )}
            </div>
            <div className={`pb-4 ml-3 d-flex flex-column ${styles.journeyStepInfo}`}>
              <div className={`d-flex align-items-center`}>
                <img
                  className={`${orderAcceptedProgress !== 'completed' ? styles.fillGray : ''}`}
                  src="/images/Grow.svg"
                />
                <span
                  className={`ml-2 ${styles.smallSemibold} ${
                    orderAcceptedProgress !== 'completed'
                      ? styles.disabledGrayText
                      : `font-weight-bold ${styles.simpleBlueText}`
                  }`}
                >
                  Grow with Arzooo!
                </span>
              </div>
              {orderAcceptedProgress == 'completed' && (
                <span className={`mt-2 ${styles.journeyDescription}`}>
                  Unlock Your Retail Potential with Arzooo: Where Growth Meets E-commerce
                </span>
              )}
            </div>
          </div>
        </div>
        {/* {catalogueProgress === 'completed' && (
          <div className={`${styles.viewMoreContainer}`}>
            <div className={`d-flex align-items-center justify-content-between`}>
              <span className={`${styles.secondaryText}`}>Top selling products</span>
              <div
                onClick={() => {
                  history.push('/recommended-products');
                }}
                className={`d-flex align-items-center ${styles.cursorP}`}
              >
                <span className={`${styles.blueText} ${styles.tinyFont}`}>View More</span>
                <img src="/images/RightArrow.svg" className={`ml-2`} />
              </div>
            </div>
            <div className={`mt-5 ${styles.viewMoreCardsContainer} ${styles.lessGap}`}>
              {totalProducts.map((product, idx) => {
                if (idx < 7) {
                  return (
                    <ProductCard
                      id={idx}
                      data={product}
                      handleInvModal={handleInvModal}
                      selectedModelFnc={selectedModelFnc}
                      showAddProduct={showAddProduct}
                      addProductObj={addProductObj}
                      setShowAddProduct={setShowAddProduct}
                      productObj={productObj}
                      addInv={addInv}
                      addLoading={addLoading}
                      errorMsg={errorMsg}
                      setErrorMsg={setErrorMsg}
                    />
                  );
                }
              })}
            </div>
          </div>
        )} */}

        {openPolicy && (
          <TermsAndConditionPage
            agreementOpen={openPolicy}
            closeAgreementOpen={setOpenPolicy}
            showTerms={true}
            showWorkingHours={true}
            disableButtons={true}
            showClose={true}
          />
        )}
      </div>
    </div>
  );
};
export default UserJourney;
